<template>
  <nav
    id="header"
    class="fixed top-0 inset-x-0 z-30 bg-white/95 backdrop-blur border-b border-gray-100 shadow-sm"
  >
    <div
      class="max-w-[1600px] mx-auto flex items-center justify-between h-16 px-4 sm:px-6 lg:px-10"
    >
      <!-- Brand -->
      <router-link class="flex items-center gap-3 flex-shrink-0" :to="{ name: 'Dashboard' }">
        <span
          class="w-9 h-9 rounded-xl bg-brand-600 text-white flex items-center justify-center"
        >
          <font-awesome-icon icon="wind" />
        </span>
        <span class="font-extrabold text-lg text-ink tracking-tight">
          Epi<span class="text-brand-600">Breath</span>
        </span>
      </router-link>

      <!-- Desktop nav -->
      <div class="hidden lg:flex items-center gap-1 ml-6 mr-auto">
        <router-link
          v-for="link in links"
          :key="link.title"
          :to="{ name: link.routeName }"
          class="nav-link px-3 py-2 rounded-xl text-sm font-semibold text-ink-soft hover:bg-gray-50"
          active-class="is-active"
        >
          <font-awesome-icon :icon="link.icon" class="mr-1.5 text-ink-muted" />
          {{ link.title }}
        </router-link>
      </div>

      <!-- Desktop user + logout -->
      <div class="hidden lg:flex items-center gap-3 flex-shrink-0">
        <div v-if="user" class="flex items-center gap-2">
          <span
            class="w-9 h-9 rounded-full bg-brand-600 text-white text-sm font-bold flex items-center justify-center select-none"
            >{{ initials }}</span
          >
          <span class="text-sm text-ink-soft font-medium">{{ user.email }}</span>
        </div>
        <router-link class="btn btn-secondary btn-sm" :to="{ name: 'Logout' }">
          <font-awesome-icon icon="sign-out-alt" />
          <span>Log out</span>
        </router-link>
      </div>

      <!-- Mobile: avatar + hamburger -->
      <div class="flex lg:hidden items-center gap-2">
        <span
          v-if="user"
          class="w-9 h-9 rounded-full bg-brand-600 text-white text-sm font-bold flex items-center justify-center select-none"
          >{{ initials }}</span
        >
        <button
          class="w-10 h-10 flex items-center justify-center rounded-xl text-ink-soft hover:bg-gray-100 focus:outline-none transition-colors"
          aria-label="Toggle menu"
          @click="menuOpen = !menuOpen"
        >
          <font-awesome-icon :icon="menuOpen ? 'times' : 'bars'" class="text-lg" />
        </button>
      </div>
    </div>

    <!-- Mobile dropdown -->
    <transition name="slide-fade">
      <div
        v-if="menuOpen"
        class="lg:hidden border-t border-gray-100 bg-white px-4 sm:px-6 pb-4 pt-2 shadow-sm"
      >
        <div class="space-y-1">
          <router-link
            v-for="link in links"
            :key="link.title"
            :to="{ name: link.routeName }"
            active-class="is-active"
            class="mobile-link flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold text-ink-soft hover:bg-gray-50 transition-colors"
            @click.native="menuOpen = false"
          >
            <font-awesome-icon :icon="link.icon" class="w-4 text-center text-ink-muted" />
            <span>{{ link.title }}</span>
          </router-link>
          <router-link
            :to="{ name: 'Logout' }"
            class="mobile-link flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold text-ink-soft hover:bg-gray-50"
            @click.native="menuOpen = false"
          >
            <font-awesome-icon icon="sign-out-alt" class="w-4 text-center text-ink-muted" />
            <span>Log out</span>
          </router-link>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { getterTypes } from 'store/auth'

export default {
  data() {
    return { menuOpen: false, links: LINKS }
  },
  computed: {
    ...mapGetters({ user: getterTypes.currentUser }),
    initials() {
      const email = (this.user && this.user.email) || ''
      return email.slice(0, 2).toUpperCase() || '·'
    },
  },
  watch: {
    $route() {
      this.menuOpen = false
    },
  },
}

const LINKS = [
  { title: 'Dashboard', routeName: 'Dashboard', icon: 'chart-line' },
  { title: 'Measurements', routeName: 'Measurements', icon: 'vials' },
  { title: 'Device suitability', routeName: 'Suitability', icon: 'tasks' },
]
</script>

<style scoped>
.nav-link.is-active,
.mobile-link.is-active {
  background-color: #fbf4fb;
  color: #831f82;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
